import * as type from './constant';

export const getNotification = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getNotificationSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getNotificationError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addNotification = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addNotificationSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateNotification = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateNotificationSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteNotification = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteNotificationSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationNotificationError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
